import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { preloadPage } from "./pages.lazy";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

// Load the current page's chunk before the first render, so the prerendered HTML
// stays on screen until React has the real page to replace it with.
preloadPage(window.location.pathname)
  .catch(() => {})
  .then(() => root.render(<App />));
